import { render, staticRenderFns } from "./WrappingCard.vue?vue&type=template&id=5672d588&lang=pug&"
import script from "./WrappingCard.vue?vue&type=script&lang=ts&"
export * from "./WrappingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports